import { ROUND_SELECT } from '../actions/round';
import { HEAT_SELECT } from '../actions/heat';
import { ATHLETE_SELECT } from '../actions/athlete';

const defaultState = null;

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case ROUND_SELECT: {
      return null;
    }

    case HEAT_SELECT: {
      return null;
    }

    case ATHLETE_SELECT: {
      if (payload) {
        return payload.externalId;
      }

      return null;
    }

    default: {
      return state;
    }
  }
};
